import css from "styled-jsx/css";
import { grid } from "../constants";

export default css`
  .bubble-componente {
    position: relative;
    min-height: min(23.18rem, 95vw);
    min-width: min(23.18rem, 95vw);
    height: min(23.18rem, 95vw);
    width: min(23.18rem, 95vw);

    overflow: visible;
    margin: 0 auto;
    margin-top: 3rem;
    margin-bottom: 5.6875rem;
  }

  // Tablet
  @media screen and (min-width: ${grid.breakpoint_sm}px) {
    .bubble-componente {
      min-height: min(35.3rem, 47vw);
      min-width: min(35.3rem, 47vw);
      height: min(35.3rem, 47vw);
      width: min(35.3rem, 47vw);
      margin: 0 0;
      padding-top: 0;
    }
  }

  // Desktop
  @media screen and (min-width: ${grid.breakpoint_md}px) {
  }
`;
